/*@flow*/
import history from 'lib/history';
import * as I from 'immutable';

export default function useBrowserQuery(): any {
  return I.fromJS(history.getQuery() || {});
}
